import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "audio",
  "use": "audio-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"audio\"><path d=\"M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 1a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-1-7.95V6h5v2h-3v4.5a2.5 2.5 0 1 1-2-2.45Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol